/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'caret-right': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M637.2 465.7L382.4 210.9c-18.9-19-34.3-12.6-34.3 14.2v549.8c0 26.8 15.4 33.1 34.3 14.2l254.8-254.8c18.9-18.9 18.9-49.7 0-68.6z"/>'
  }
})
